import React from "react";
import ExperienceItem from "./ExperienceItem";
import { data } from "../libs/data";

export default function ExperienceCard() {
  return (
    <div className="w-full font-sans text-gray-300 flex flex-col h-[50vh] lg:h-[68vh]">
      <div className="font-semibold text-4xl text-gray-300 px-5 pt-5 pb-3 shrink-0">
        Experience
      </div>
      <div className="flex-1 min-h-0 overflow-y-auto experience-scroll px-5">
        {data.map((item, i) => (
          <ExperienceItem key={i} {...item} isLast={i === data.length - 1} />
        ))}
      </div>
    </div>
  );
}
